module.exports = __webpack_public_path__ + "fonts/b172e7d19fbd942d3d81e59a1bb42498.svg";